import Cookies from 'js-cookie';
import firebase from 'firebase/app';
import 'firebase/auth';
import {BaseView} from './core/view';
import {Device, MobileUtil, Range} from "./utils/mobile"
import { TrackingUtil } from './utils/tracking';
import { LinkUtil } from './utils/link';
import { Modal, ModalTypes } from './modal/modal';
import HeaderAutoHide from './utils/headerautohide';
import { ClassUtil } from "./utils/class-util"
import { FirebaseApp } from './utils/firebase-app';
import { FirebaseAuthCookie } from './account/firebase-auth-cookie';
import { Anchored } from './utils/anchored';
import { StringUtil } from "./utils/string-util"
import {BrowserSupport} from "./utils/browser-support"
import constants from './utils/constants';

//import PushNotifications from './utils/push-notifications';

export default BaseView.extend({

    el: 'body',
    cookieHint: document.querySelector(".js-cookie-hint"),

    events: {
        'click [data-bind=accordion].click-only > li': 'toggleAccordion',
        'click [data-co]': 'onClickMakeClickout',
        'click [data-is-real-link]': 'onClickTrackClickout',
        'click [data-link]': 'onClickRedirect',
        'click [data-link-blank]': 'onClickNewTab',
        'click [data-bind=checkbox]': 'onClickTriggerCustomCheckbox',
        'click [data-bind=radioset] .option:not(.active)': 'onClickTriggerCustomRadioset',
        'click [bubbles=false]': 'onPreventBubbleClick',
        'click .js-product-preview-search-page-link': 'stopPropagation',
        'click .close-mobile-push': 'clickMobileAppPushBanner',
        'click [data-bind=close-search]': 'onClickCloseMobileMenus',
        'click .js-side-navigation-trigger': 'onClickToggleSideNavigation',
        'click .modal__overlay': 'onClickHideSideNavigation',
        'click .js-navigation__track-link': 'onClickTrackNavigationLink',
        'click .js-navigation-logo': 'onClickTrackHomeLink',
        'click .js-voucher-code': 'showVoucherCodeModal',
        'click .js-close-cookie-hint': 'hideCookieHint',
        'click .js-anchor-link': Anchored.scrollClick.bind(Anchored),
        'click .js-back-button': 'onBackButtonClicked',
        'click .js-to-top-button': 'toTopButtonClicked',
        'click .js-voucher-copy': 'copyVoucherCode'
    },

    initialize: function () {
        const modal = new Modal();
        modal.initializeMarkup();

        this.handleTouchClass();
        
        if (!MobileUtil.isMediaQuery(Device.TABLET, Range.UP)) {
            HeaderAutoHide.activateMobileHeaderAutoHide();
        }
        
        if (BrowserSupport.isIE()) {
            ClassUtil.addClass(this.el, 'is-internet-explorer');
        }

        if (BrowserSupport.isSafariTo10()) {
            ClassUtil.addClass(this.el, 'is-safari-to-10');
        }

        this.initializeCookieHint();
        this.initializeMobileAppPushBanner();

        FirebaseApp.initialize();
        this.handleUserAuthentication();

//        const isPushNotificationsTestActive = this.$el.hasClass("js-web-pushes-enabled");
//        if (isPushNotificationsTestActive) {
//            PushNotifications.initialize();
//        }
    },

    onPreventBubbleClick: function(event){
        event.cancelBubble = true;
        event.stopPropagation();
    },

    toTopButtonClicked: function(){
        window.scroll(0,0);
    },
    
    onClickTrackNavigationLink: function(e) {
        let label = this.$el.find(e.currentTarget).text().trim();
        TrackingUtil.throwGAEvent('Navigation', 'clicked', label, false);
    },
    
    onClickTrackHomeLink: function(e) {
        TrackingUtil.throwGAEvent('Navigation', 'clicked', 'Logo', false);
    },
    
    onClickToggleSideNavigation: function(e) {
        if(!$('.side-navigation--is-open').length) {
            TrackingUtil.throwGAEvent('Navigation', 'clicked', 'Hamburger', false);
        }

        this.$el.toggleClass('side-navigation--is-open');
    },
    
    onClickHideSideNavigation: function() {
		this.el.classList.remove('side-navigation--is-open');

        document.body.classList.remove('new-filters--is-open');
        document.body.classList.remove('no-scroll');
        document.querySelector('html').classList.remove('no-scroll');
        let filtersMenu = document.querySelector('.js-filters-menu');
        filtersMenu && filtersMenu.classList.remove('new-filters__menu--open--animate');
        setTimeout(() => {
            filtersMenu && filtersMenu.classList.remove('new-filters__menu--open');
        }, 500);
    },

    /**
     * To trigger a click out on a non-native link (div wrapper) click
     *
     * @param e
     * @returns {boolean}
     */
    onClickMakeClickout: function (e) {
        const productId = this.$el.find(e.currentTarget).data('co');
        const productUuid = this.$el.find(e.currentTarget).data('product-uuid');
        const link = this.$el.find(e.currentTarget).data('go');
        const location = this.$el.find(e.currentTarget).closest('[data-co-location]').data('co-location');
        let pageId = "undefined";
        if(typeof dataLayer !== 'undefined') {
            const mapObj = Array.prototype.filter.call(dataLayer, (obj) => Object.keys(obj) == "map")[0];
            pageId = mapObj.map["gtmTrackingPageId"];
        }

        LinkUtil.clickout(productId, productUuid, link, true, true, pageId, location);

        return false;
    },

    /**
     * To track a click out on a native link click
     *
     * @param e
     */
    onClickTrackClickout: function (e) {
        const productId = this.$el.find(e.currentTarget).data('product-id');
        const productUuid = this.$el.find(e.currentTarget).data('product-uuid');
        const location = this.$el.find(e.currentTarget).closest('[data-co-location]').data('co-location');

        LinkUtil.trackClickout(productId, productUuid, location);
    },

    onBackButtonClicked: function(e) {

        let HOS_DOMAIN = "houseofsneakers";
        let STYLIGHT_DOMAIN = "stylight";
        let defaultUrl = "/Sneakers/";

        if (document.referrer) {
            let referrer = document.createElement('a');
            referrer.href = document.referrer;
            let ownReferrer = referrer.host.includes(HOS_DOMAIN) ||
                              referrer.host.includes(STYLIGHT_DOMAIN);

            if (ownReferrer) {
                var prevPage = window.location.href;
                window.history.back();
                setTimeout(() => {
                    if (window.location.href == prevPage) {
                        window.location.href = defaultUrl;
                    }
                }, 500);
                return;
            }
        }

        window.location.href = defaultUrl;
    },

    showVoucherCodeModal: function (e) {
        e.stopPropagation();
        e.preventDefault();

        let modalData = {};

        if (!document.querySelector('.js-deals-enabled') || 
             document.querySelector('.is-logged-in')) {
            modalData.type = ModalTypes.VOUCHER;
            modalData.productUuid = this.$el.find(e.currentTarget).data('product-uuid');
        } else {
            let has_acct = Cookies.get(constants.COOKIE_IS_REGISTERED) === "true";
            modalData.type = has_acct ? ModalTypes.LOGIN : ModalTypes.SIGNUP;
            modalData.url = location.href;
        }

        new Modal().show(modalData);
    },
    
    stopPropagation: (e) => e.stopPropagation(),

    handleTouchClass: function () {
        if (MobileUtil.isTouch()) {
            this.$el.addClass('touch');
        } else {
            this.$el.addClass('no-touch');
        }
    },

    toggleAccordion: function (e) {
        // activate clicked element and deactivate all others
        if (e.currentTarget.nodeName !== "INPUT" && !$(e.currentTarget).hasClass('checkbox') && e.currentTarget.className !== "filter-delete" && !$(e.currentTarget).hasClass('filter-disabled')) {
            var el = this.$el.find(e.currentTarget),
                toClose = el.parent().find('li.active').not(el),
                timeOut = 0;
            if (toClose.length) {
                toClose.removeClass('active');
                timeOut = 100;
            }
            setTimeout(() => {
                el.toggleClass('active');
            }, timeOut);
        }
    },

    onClickRedirect: function (e) {
        e.preventDefault();
        e.stopPropagation();
        var element = this.$el.find(e.currentTarget);
        LinkUtil.goToUrl(element.data('link'));
    },

    onClickNewTab: function (e) {
        var element = this.$el.find(e.currentTarget);
        LinkUtil.goToUrlBlank(element.data('link-blank'));
    },

    onClickTriggerCustomCheckbox: function (e) {
        var current = this.$el.find(e.currentTarget);
        current.toggleClass('active');
        var el = current.find('input');

        if (el.is(":checked")) {
            el.attr('checked', false);
        } else {
            el.attr('checked', true);
        }
    },

    onClickTriggerCustomRadioset: function (e) {
        // switch radioboxes
        this.$el.find(e.currentTarget).parent().children('.option').toggleClass('active');
        this.$el.find(e.currentTarget).find('input').attr('checked', true).trigger('click');
    },

    initializeCookieHint: function () {
        if(this.cookieHint) {
            let cookieName = this.cookieHint.getAttribute('data-cookie-hint-name');
            if (!Cookies.get(cookieName)) {
                Cookies.set(cookieName, 0, {
                    expires: 100,
                    path: '/',
                    secure: true
                });
                ClassUtil.removeClass(this.cookieHint, 'hide');
            } else {
                this.addGdprVariables();
            }
        }
    },
    
    hideCookieHint: function() {
        ClassUtil.addClass(this.cookieHint, 'hide');
        this.addGdprVariables();
    },
    
    addGdprVariables: function() {
        window.__rmcp = [1,2,3,4,5];
    },

    initializeMobileAppPushBanner: function () {
        if (Cookies.get('mobile-app-read')) {
            this.$el.find(e.currentTarget).closest('.mobile-app-push').addClass('hide');
        }
    },

    clickMobileAppPushBanner: function (e) {
        //mobile push banner > cookie to set the banner as read
        this.$el.find(e.currentTarget).closest('.mobile-app-push').addClass('hide');
        //set the cookie as the banner has been read
        Cookies.set('mobile-app-read', true, {
            expires: 3,
            path: '/',
            secure: true
        });
    },

    handleUserAuthentication: function () {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                user.getIdToken().then(FirebaseAuthCookie.setToken);
            }
            else {
                FirebaseAuthCookie.clear();
            }
        });
    },

    copyVoucherCode: function(e){
        let current = e.currentTarget;

        let code = current.getAttribute("data-code");

        if(StringUtil.copyToClipboard(current, code)){
            current.parentNode.querySelector(".js-copy-success").classList.add("transparent--visible");

            setTimeout(() => current.parentNode.querySelector(".js-copy-success").classList.remove("transparent--visible"), 1000);
        }
    }
})
